import React from "react";
import { PickersDay, Badge, Icon } from "investira.react.components";

function ServerDay(props) {
  const {
    highlightedDays = [],
    posicoesAbertas = [],
    onlyHighlightAble = false,
    day,
    outsideCurrentMonth = false,
    ...other
  } = props;

  const xDay = day.format("DDMMYYYY");

  const isHighlighted =
    !outsideCurrentMonth && highlightedDays.indexOf(day.date()) >= 0;

  const xPickersDayProps = {
    ...other,
    outsideCurrentMonth,
    day,
    ...(onlyHighlightAble && { disabled: !isHighlighted }),
  };

  const xIsAberta = posicoesAbertas[xDay];

  return (
    <Badge
      key={props.day.toString()}
      color={"warning"}
      invisible={!isHighlighted}
      overlap="circular"
      variant={xIsAberta ? "standard" : "dot"}
      badgeContent={
        xIsAberta ? <Icon iconName="box_3d_open" size={12} /> : null
      }
      size={"small"}
    >
      <PickersDay {...xPickersDayProps} />
    </Badge>
  );
}

ServerDay.displayName = "ServerDay";

export default ServerDay;
